import React from 'react';
import Head from 'next/head';
import { SITE_FONT } from 'constants/site';

function Webfont() {
  return SITE_FONT === 'brandon-grotesque' ? (
    <Head>
      <link
        as="style"
        rel="preload"
        href="https://use.typekit.net/lmz0uii.css"
      />
      <link rel="stylesheet" href="https://use.typekit.net/lmz0uii.css" />
    </Head>
  ) : (
    <style jsx global>{`
      @font-face {
        font-family: 'Playfair Display';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: local('Playfair Display Regular'), local('PlayfairDisplay-Regular'),
          url('/static/fonts/playfair-display-v14-latin-regular.woff2')
            format('woff2'),
          url('/static/fonts/playfair-display-v14-latin-regular.woff')
            format('woff');
      }
      @font-face {
        font-family: 'Playfair Display';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: local('Playfair Display Bold'), local('PlayfairDisplay-Bold'),
          url('/static/fonts/playfair-display-v14-latin-700.woff2')
            format('woff2'),
          url('/static/fonts/playfair-display-v14-latin-700.woff')
            format('woff');
      }
    `}</style>
  );
}

export default Webfont;
